import { datasetTypes } from "./map";

export let allLayers = [
  {
    id: "Dibrugarh_boundary",
    display: true,
    type: datasetTypes.POLYGON,
    name: "Dibrugarh boundary",
    // tslint:disable-next-line:max-line-length
    // url: 'http://localhost:8080/geoserver/Dibrugarh/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=Dibrugarh:dibrugarh_boundary&maxFeatures=50&outputFormat=application%2Fjson',
    url: "https://gis.spatialdecisions.com/geoserver/Dibrugarh/ows?service=WFS&version=1.1.0&request=GetFeature&typename=Dibrugarh:Dibrugarh%20boundary&outputFormat=application/json",
    textStyle: {
      layout: {
        "text-font": ["Roboto Regular"],
        "text-size": 15,
        "text-offset": [0, 0],
        "symbol-placement": "point",
        "text-allow-overlap": true,
        "text-field": "{name}",
      },
      paint: {
        "text-color": "#000",
        "text-halo-color": "white",
        "text-halo-width": 2,
        "text-halo-blur": 1,
      },
    },
    polylineStyle: {
      paint: {
        "line-width": 3,
        // 'line-color': '#ebeaea',
        "line-color": "black",
        "line-dasharray": [2, 1, 2, 1, 2, 1],
      },
      layout: {},
    },
    polygonStyle: {
      paint: {
        "fill-color": "transparent",
        "fill-opacity": 1,
      },
      layout: {},
    },
    className: "dibrugarh-boundary",
  },
  {
    id: "watershed",
    display: true,
    type: datasetTypes.POLYGON,
    name: "Watershed",
    // tslint:disable-next-line:max-line-length
    // url: 'http://localhost:8080/geoserver/Dibrugarh/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=Dibrugarh:watershed&maxFeatures=50&outputFormat=application%2Fjson',
    url: "https://gis.spatialdecisions.com/geoserver/Dibrugarh/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=Dibrugarh%3AWatershed&maxFeatures=50&outputFormat=application%2Fjson",
    textStyle: {
      layout: {
        "text-font": ["Roboto Regular"],
        "text-size": 15,
        "text-offset": [0, 0],
        "symbol-placement": "point",
        "text-allow-overlap": false,
        "text-field": "{region}",
      },
      paint: {
        "text-color": "#000",
        "text-halo-color": "white",
        "text-halo-width": 2,
        "text-halo-blur": 1,
      },
    },
    polylineStyle: {
      paint: {
        "line-width": 3,
        // 'line-color': '#e5f1fb',
        "line-color": "grey",
      },
      layout: {},
    },
    polygonStyle: {
      paint: {
        "fill-color": {
          property: "river_name",
          type: "categorical",
          stops: [
            ["Maijan", "#ebf489"],
            ["Sessa", "#82e6d9"],
            ["Buridehing", "#9bc9f3"],
          ],
        },
        "fill-opacity": 0.6,
      },
      layout: {},
    },
    className: ["watershed-Maijan", "watershed-Sessa", "watershed-Buridehing"],
  },
  {
    id: "Municipal_boundary",
    display: true,
    type: datasetTypes.POLYGON,
    name: "Municipal boundary",
    // tslint:disable-next-line:max-line-length
    // url: 'http://localhost:8080/geoserver/Dibrugarh/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=Dibrugarh:muncipalbndry&maxFeatures=50&outputFormat=application%2Fjson',
    url: "https://gis.spatialdecisions.com/geoserver/Dibrugarh/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=Dibrugarh%3AMunicipal%20boundary&maxFeatures=50&outputFormat=application%2Fjson",
    textStyle: {
      layout: {
        "text-font": ["Roboto Regular"],
        "text-size": 15,
        "text-offset": [0, 0],
        "symbol-placement": "line-center",
        "text-allow-overlap": true,
        "text-field": "{name}",
      },
      paint: {
        "text-color": "#000",
        "text-halo-color": "white",
        "text-halo-width": 2,
        "text-halo-blur": 1,
      },
    },
    polylineStyle: {
      paint: {
        "line-width": 3,
        "line-color": "#f97e10",
        "line-dasharray": [2, 1],
      },
      layout: {},
    },
    polygonStyle: {
      paint: {
        "fill-color": "transparent",
        "fill-opacity": 1,
      },
      layout: {},
    },
    className: "municipal-boundary",
  },
  {
    id: "Master_plan_boundary",
    display: true,
    type: datasetTypes.POLYGON,
    name: "Master plan boundary",
    // tslint:disable-next-line:max-line-length
    // url: 'http://localhost:8080/geoserver/Dibrugarh/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=Dibrugarh:masterplanbdry&maxFeatures=50&outputFormat=application%2Fjson',
    url: "https://gis.spatialdecisions.com/geoserver/Dibrugarh/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=Dibrugarh%3AMaster%20plan%20boundary&maxFeatures=50&outputFormat=application%2Fjson",
    textStyle: {
      layout: {
        "text-font": ["Roboto Regular"],
        "text-size": 15,
        "text-offset": [0, 0],
        "symbol-placement": "point",
        "text-allow-overlap": true,
        "text-field": "{name}",
      },
      paint: {
        "text-color": "#000",
        "text-halo-color": "white",
        "text-halo-width": 2,
        "text-halo-blur": 1,
      },
    },
    polylineStyle: {
      paint: {
        "line-width": 3,
        "line-color": "#ff4545",
      },
      layout: {},
    },
    polygonStyle: {
      paint: {
        "fill-color": "transparent",
        "fill-opacity": 1,
      },
      layout: {},
    },
    className: "master-plan-boundary",
  },
  {
    id: "subbasin",
    display: true,
    type: datasetTypes.POLYGON,
    name: "Subbasin",
    // tslint:disable-next-line:max-line-length
    // url: 'http://localhost:8080/geoserver/Dibrugarh/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=Dibrugarh:subbasin&maxFeatures=50&outputFormat=application%2Fjson',
    url: "https://gis.spatialdecisions.com/geoserver/Dibrugarh/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=Dibrugarh%3ASubbasin&maxFeatures=50&outputFormat=application%2Fjson",
    textStyle: {
      layout: {
        "text-font": ["Roboto Regular"],
        "text-size": 15,
        "text-offset": [0, 0],
        "symbol-placement": "point",
        "text-allow-overlap": false,
        "text-field": "{subbasin}",
      },
      paint: {
        "text-color": "#000",
        "text-halo-color": "white",
        "text-halo-width": 2,
        "text-halo-blur": 1,
      },
    },
    polylineStyle: {
      paint: {
        "line-width": 1,
        "line-color": "black",
      },
      layout: {},
    },
    polygonStyle: {
      paint: {
        // 'fill-color': 'transparent',
        "fill-color": "#B2BABB",
        "fill-opacity": 0.5,
      },
      layout: {},
    },
    className: "subbasin",
  },
  {
    id: "floodprone",
    display: true,
    type: datasetTypes.POLYGON,
    name: "Flood Prone",
    // tslint:disable-next-line:max-line-length
    // url: 'http://localhost:8080/geoserver/Dibrugarh/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=Dibrugarh:floodprone&maxFeatures=50&outputFormat=application%2Fjson',
    url: "https://gis.spatialdecisions.com/geoserver/Dibrugarh/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=Dibrugarh%3AFlood%20prone&maxFeatures=50&outputFormat=application%2Fjson",
    textStyle: {
      layout: {
        "text-font": ["Roboto Regular"],
        "text-size": 15,
        "text-offset": [0, 0],
        "symbol-placement": "point",
        "text-allow-overlap": true,
        "text-field": "{name}",
      },
      paint: {
        "text-color": "#000",
        "text-halo-color": "white",
        "text-halo-width": 2,
        "text-halo-blur": 1,
      },
    },
    polygonStyle: {
      paint: {
        "fill-color": "#f2a7f8",
        "fill-opacity": 0.6,
      },
      layout: {},
    },
    className: "floodprone",
  },
  {
    id: "Wetlands",
    display: true,
    type: datasetTypes.POLYGON,
    name: "Wetlands",
    // tslint:disable-next-line:max-line-length
    // url: 'http://localhost:8080/geoserver/Dibrugarh/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=Dibrugarh:wetlands_dbr&maxFeatures=50&outputFormat=application%2Fjson',
    url: "https://gis.spatialdecisions.com/geoserver/Dibrugarh/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=Dibrugarh%3AWetlands&maxFeatures=50&outputFormat=application%2Fjson",
    textStyle: {
      layout: {
        "text-font": ["Roboto Regular"],
        "text-size": 15,
        "text-offset": [0, 0],
        "symbol-placement": "point",
        "text-allow-overlap": true,
        "text-field": "{name}",
      },
      paint: {
        "text-color": "#000",
        "text-halo-color": "white",
        "text-halo-width": 2,
        "text-halo-blur": 1,
      },
    },
    polygonStyle: {
      paint: {
        "fill-color": "#9fdaf4",
        "fill-opacity": 0.6,
      },
      layout: {},
    },
    className: "wetlands",
  },
  {
    id: "River",
    display: true,
    type: datasetTypes.POLYLINE,
    name: "River",
    // tslint:disable-next-line:max-line-length
    // url: 'http://localhost:8080/geoserver/Dibrugarh/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=Dibrugarh:river&maxFeatures=50&outputFormat=application%2Fjson',
    url: "https://gis.spatialdecisions.com/geoserver/Dibrugarh/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=Dibrugarh%3ARiver&maxFeatures=50&outputFormat=application%2Fjson",
    textStyle: {
      layout: {
        "text-font": ["Roboto Regular"],
        "text-size": 13,
        "text-offset": [0, 3.5],
        "symbol-placement": "line-center",
        "text-allow-overlap": true,
        "text-field": "{river_name}",
      },
      paint: {
        "text-color": "#0406ff",
        "text-halo-color": "white",
        "text-halo-width": 2,
        "text-halo-blur": 1,
      },
    },
    polylineStyle: {
      paint: {
        "line-width": 3,
        "line-color": "#0406ff",
      },
      layout: {},
    },
    className: "river",
  },
  {
    id: "Drainage",
    display: true,
    type: datasetTypes.POLYLINE,
    name: "Drainage",
    // tslint:disable-next-line:max-line-length
    // url: 'http://localhost:8080/geoserver/Dibrugarh/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=Dibrugarh:drainsections&maxFeatures=50&outputFormat=application%2Fjson',
    url: "https://gis.spatialdecisions.com/geoserver/Dibrugarh/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=Dibrugarh%3ADrainage&maxFeatures=50&outputFormat=application%2Fjson",
    textStyle: {
      layout: {
        "text-font": ["Roboto Regular"],
        "text-size": 15,
        "text-offset": [0, 0],
        "symbol-placement": "line-center",
        "text-allow-overlap": false,
        "text-field": "{name}",
      },
      paint: {
        "text-color": "#000",
        "text-halo-color": "white",
        "text-halo-width": 2,
        "text-halo-blur": 1,
      },
    },
    polylineStyle: {
      paint: {
        "line-width": 3,
        "line-color": "#147bff",
      },
      layout: {},
    },
    className: "drainage",
  },
  {
    id: "District_headquarter",
    display: true,
    type: datasetTypes.POINT,
    name: "District headquarter",
    // tslint:disable-next-line:max-line-length
    // url: 'http://localhost:8080/geoserver/Dibrugarh/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=Dibrugarh:headquarter&maxFeatures=50&outputFormat=application%2Fjson',
    url: "https://gis.spatialdecisions.com/geoserver/Dibrugarh/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=Dibrugarh%3ADistrict%20headquarter&maxFeatures=50&outputFormat=application%2Fjson",
    textStyle: {
      layout: {
        "text-font": ["Roboto Regular"],
        "text-size": 16,
        "text-offset": [0, 2],
        "symbol-placement": "point",
        "text-allow-overlap": false,
        "text-field": "{town}",
      },
      paint: {
        "text-color": "#000",
        "text-halo-color": "white",
        "text-halo-width": 2,
        "text-halo-blur": 1,
      },
    },
    symbolStyle: {
      paint: {
        "icon-halo-width": 1,
        "icon-color": "#e60027",
        "icon-halo-color": "transparent",
      },
      layout: {
        "icon-size": 0.5,
        "icon-image": "point",
        "icon-allow-overlap": false,
      },
    },
    className: "district-headquarter",
    icon: `assets/images/point.png`,
  },
];
